import React, { Component } from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment';
import Cookies from 'universal-cookie';
import IconButton from 'material-ui/IconButton';
import RaisedButton from 'material-ui/RaisedButton';
import Tabs from 'muicss/lib/react/tabs';
import Tab from 'muicss/lib/react/tab';
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';
import { NotificationManager } from 'react-notifications';
import LoadingBoxes from '../components/loadingBoxes';
import LoadingText from '../components/loadingText';
import Card_Custom from '../components/card';
import ProfileSectionTop from '../components/profileSectionTop';
import ProfileSourceTab from '../components/profileSourceTab';
import RenderPopularBoxInfo from '../components/renderPopularBoxInfo';
import { fetch_kolprofile } from '../actions/fetch_kolprofile';
import { fetch_postlist } from '../actions/fetch_postlist';
import { fetch_myfavorite } from '../actions/fetch_myfavorite';
import { numberWithCommas, reloadPage, checkMylistStatusCode } from '../utility/tool';
import { userLogout } from '../utility/logout';
import '../styles/kolprofile.css';
import '../styles/k_sprite1.css';
import '../styles/posttype.css';
import '../styles/profileSourceTab.css';
import '../styles/spriteProfileTab.css';
import '../styles/sprite5.css';

let cookies = new Cookies();

const ProfileInlineStyle = {
	floatingLabelStyle : {
	    color: 'rgba(0, 0, 0, 0.6)'
	},
	inputError:{
	    position: 'absolute',
	    left: '0',
	    bottom: '-10px'
	},
	inputFavoriteStyle: {
		width: '200px',
		marginRight: '20px',
		verticalAlign: 'middle',
		fontFamily: '"Noto Sans TC","WenQuanYi Zen Hei","Heiti TC","Helvetica","Microsoft YaHei","Microsoft JhengHei","Arial","sans-serif"',
	},
	createFavoriteRootStyle: {
		marginTop: '15px',
		height: '40px',
		verticalAlign: 'middle',
		fontFamily: '"Noto Sans TC","WenQuanYi Zen Hei","Heiti TC","Helvetica","Microsoft YaHei","Microsoft JhengHei","Arial","sans-serif"',
	},
	createFavoriteBtnStyle: {
		height:'40px',
		lineHeight: '40px',
		verticalAlign: 'middle',
		fontFamily: '"Noto Sans TC","WenQuanYi Zen Hei","Heiti TC","Helvetica","Microsoft YaHei","Microsoft JhengHei","Arial","sans-serif"',
	}
}

class Profile extends Component {
	constructor(props){
		super(props)
		this.state = {
			formData: {
				name: '',
				collectionId: '',
				kols: props.location.query.uuid,
			},
			checkSavedFavorite: false,
			favoriteList: '',
			submitted: false,
			checkList: []
		}
	}

	componentDidMount(){
		window.scrollTo(0, 0)

		const { location } = this.props
		const { formData } = this.state
		const { uuid, ...newQuery } = location.query

		if(location.query.fid) {
			this.props.fetch_kolprofile(newQuery, cookies.get('user_id'), cookies.get('token'))
			this.props.fetch_postlist(location.query.fid, 180, location.query.tags, 'FB,YT,IG', cookies.get('token'))
		}

		if(cookies.get('user_id') && location.query.uuid) {
			this.props.fetch_myfavorite(cookies.get('user_id'), location.query.uuid, 'get_kolId', cookies.get('token'))
		}

	}

	componentDidUpdate(prev){
		const { myfavorite } = this.props

		if(prev.myfavorite !== myfavorite) {
			let newList = myfavorite.data.filter((item,index) => {
				return item.active === 1
			}).map((item2) => {
				return item2.id
			})

			let checkSavedFavorite = myfavorite.data.some((item,index) => {
				return item.active === 1
			})

			this.setState({
				checkList: newList,
				checkSavedFavorite: checkSavedFavorite
			})

			checkMylistStatusCode(myfavorite.status.code)

		}

	}

	openFavoritePop = () => {
		this.setState({
			favoriteList:'open',
		})
	}

	closeFavoritePop = () => {
		this.setState({
			favoriteList:'',
		})
	}

	handleChange = (event,value) => {
	    const { formData } = this.state
	    formData[event.target.name] = event.target.value.trim()
	    this.setState({ formData })
	}

	addActiveClass = (el,isSelected) => {
		let listArray = this.state.checkList

		listArray = listArray.filter((item) => {
			return item !== el.id
		})

		if (isSelected !== 'active') {
			listArray.push(el.id)
		}

		this.setState({ checkList: listArray })
	}

	submitGroupList = () => {
		const { location } = this.props
		const { submitted, checkList } = this.state
		let params = {
			collectionId: checkList.join(),
			kols: location.query.uuid,
		}

		if (submitted) {
		    return
		}

		if (!checkList.length){
			return NotificationManager.error('請至少選取一個群組', '失敗', 5000)
		}

		this.props.fetch_myfavorite(cookies.get('user_id'), params , 'put', cookies.get('token'))

		this.setState({ submitted: true, favoriteList:'' }, () => {
		    setTimeout(() => this.setState({ submitted: false }), 2000)
		})
	}

	addFavoriteList = () => {
		const { myfavorite } = this.props
	    const { formData, submitted } = this.state
	    const groupLimit = 20

	    if (submitted) {
	        return
	    }

	    if (myfavorite.data.length === groupLimit){
	    	return NotificationManager.error('群組最多新增20筆', '失敗', 5000)
	    }

	    if (myfavorite.data.length && this.checkDuplicateName()) {
	    	return NotificationManager.error('收藏群組名稱不得重複', '失敗', 5000)
	    }

	    this.props.fetch_myfavorite(cookies.get('user_id'), formData, 'post', cookies.get('token'))

	    this.setState({ submitted: true }, () => {
	        setTimeout(() => this.setState({ submitted: false }), 2000)
	    })
	}

	checkDuplicateName(){
		const { myfavorite } = this.props
		const { formData } = this.state
		let result = false

		result = myfavorite.data.some((item)=>{
			return item.name === formData.name
		})

		return result
	}

	checkEmptyTag(locationQuery, postlist){
		if(locationQuery.tags.length){
			return (
				<div className="keyword_post">
					<p className="sectionTitle">近半年關鍵字貼文</p>
					{this.renderKeywordBoxInfo(postlist.data)}
				</div>
			)
		}
	}

	renderKeywordBoxInfo(postlistData){
	    const keywordGroup = [];

	    postlistData.tag_post.forEach((item,index) => {
    	    keywordGroup.push(
    	    	<div className="keywordSection" key={index}>
    	    		<div className="keywordTitle">
    	    			<span className="k_sprite1 sprite-icon-arrow"></span>
    	    			<span className="keyword">符合關鍵字<span className="colorize">[{item.tag}]</span>的貼文</span>
    	    		</div>
    	    		<Card_Custom cardinfo={item.postlist} showSourceIcon={true}/>
    	    	</div>
    	    )
	    })

	    return (
	        <div>{keywordGroup}</div>
	    )
	}

	renderMyfavoriteSection(){
		const { myfavorite, location } = this.props
		const { formData } = this.state

		if(!cookies.get('user_id') || !location.query.uuid) {
			return
		}

		return (
			<div className="addToFavorite">
				{this.checkHeartIconStatus()}
				<div className={`insertPopWrapper bounce-in-bottom ${this.state.favoriteList}`}>
					<span className="sprite5 sprite-icon-close" onClick={this.closeFavoritePop}></span>
					<p className="description">加入收藏群組</p>
					<ValidatorForm
					    ref={r => (this.form = r)}
					    onSubmit={this.addFavoriteList}
					>
						<div className="inputBox m_b_20px">
							<TextValidator
							    floatingLabelText="輸入新增群組名稱"
							    onChange={this.handleChange}
							    name="name"
							    value={formData.name}
							    validators={['required']}
							    errorMessages={['名稱為必塡欄位']}
							    className="textValidator"
							    style={ProfileInlineStyle.inputFavoriteStyle}
							    floatingLabelStyle={ProfileInlineStyle.floatingLabelStyle}
							    errorStyle={ProfileInlineStyle.inputError}
							    underlineFocusStyle = {{borderColor:'#f48500'}}
							/>

							<RaisedButton
							  className="addToFavoriteBtn"
							  label="新增"
							  type="submit"
							  backgroundColor="#32333d"
							  style={ProfileInlineStyle.createFavoriteRootStyle}
							  buttonStyle={ProfileInlineStyle.createFavoriteBtnStyle}
							  labelColor="#fff"
							/>
						</div>
					</ValidatorForm>
					{this.renderFavoriteList(myfavorite)}
					<div className="submitGroupList" onClick={()=> this.submitGroupList()}>加入收藏</div>
				</div>
			</div>
		)
	}

	checkHeartIconStatus(){
		const { checkSavedFavorite } = this.state

		if (checkSavedFavorite) {
			return (
				<div id="heartBeat" className="myListIcon favorite" onClick={this.openFavoritePop}>
					<p>已收藏</p>
				</div>
			)
		} else {
			return (
				<div id="heartBeat" className="myListIcon notFavorite" onClick={this.openFavoritePop}>
					<p>加入收藏</p>
				</div>
			)
		}

	}

	renderFavoriteList(myfavorite){
		let myfavoriteList = []

		if(myfavorite.data.length) {
			myfavoriteList = myfavorite.data.map((el,idx) => {
				let isSelected = this.state.checkList.indexOf(el.id) > -1 ? 'active' : ''
				return <p key={el.id} className={`favoriteList ${isSelected}`}  onClick={()=> this.addActiveClass(el,isSelected)}>{el.name}</p>
			})
		}

		return (
		    <div className="favoriteListWrap">{myfavoriteList}</div>
		)

	}

  	render() {
		const {
			location,
			kolprofile,
			kolprofile_isloading,
			kolprofile_error,
			postlist,
			postlist_isloading,
			postlist_error,
			myfavorite,
			myfavorite_isloading,
			myfavorite_error,
		} = this.props;

		// show error message if no fid
		if(location.query.fid === ''){
  	  		return (
				<div className="errormsg">
					<p className="errormsgCenter">請重新點選KOL</p>
					<Link to="/" className="refreshBtn">
						<span className="refreshIconText">點我去首頁</span>
					</Link>
				</div>
  	  		)
		}

	  	if(kolprofile_isloading || postlist_isloading || myfavorite_isloading){
	  		return(
	  		  <div>
	  		    <LoadingBoxes />
	  		    <LoadingText />
	  		  </div>
	  		)
	  	}

		if(kolprofile.data === null || kolprofile.data === undefined || kolprofile.data.meta.value === null){
  	  		return (
				<div className="errormsg">
					<p className="errormsgCenter">查無資料，請重新搜尋</p>
					<Link to="/" className="refreshBtn">
						<span className="refreshIconText">點我去首頁</span>
					</Link>
				</div>
  	  		)
		}

	  	if(kolprofile_error !== false || postlist_error !== false || myfavorite_error !== false) {
			if(kolprofile_error.status === 401 || postlist_error.status === 401 || myfavorite_error.status === 401) {
				setTimeout(function(){ userLogout(); }, 3000);
				return <p className="errormsg">您的登入期間已過期，請重新登入</p>;
	  		} else {
	  	  		return (
					<div className="errormsg">
						<p className="errormsgCenter">資料未完成載入，請稍後再試</p>
						<div className="refreshBtn" onClick={() => {reloadPage()}}>
							<span className="refreshIcon"></span>
							<span className="refreshIconText">重新整理</span>
						</div>
					</div>
	  	  		)
	  		}
	  	}

	    // get date
	    const cateChipsData = location.query.skills + ',' + location.query.jobs
	    const chipsData = location.query.tags
	    const fansMin = location.query.fans_min
	    const fansMax = location.query.fans_max
	    const sinceDate = moment().subtract(location.query.period, 'days').format('YYYY/MM/DD').toString()
	    const untilDate = moment().format('YYYY/MM/DD').toString()
	    const sourceValue = location.query.source

	    return(
			<div className="profile_wrapper">
				<ProfileSectionTop leaderInfo={kolprofile.data.meta} metaValue={true}/>
				{this.renderMyfavoriteSection()}
				<div className="profile_section3">
					<div className="queryInfoBox">
						<p className="queryInfoTitle big">您的篩選條件</p>
					</div>
					<div className="queryInfoBox">
						<p className="queryInfoTitle">屬性：</p>
						<p className="queryInfoData">{cateChipsData.replace(/(^,)|(,$)/g, "")}</p>
					</div>
					<div className="queryInfoBox">
						<p className="queryInfoTitle">貼文關鍵字：</p>
						<p className="queryInfoData">{chipsData}</p>
					</div>
					<div className="queryInfoBox">
						<p className="queryInfoTitle">粉絲規模：</p>
						<p className="queryInfoData">{numberWithCommas(fansMin)} ~ {numberWithCommas(fansMax)}</p>
					</div>
					<div className="queryInfoBox">
						<p className="queryInfoTitle">查詢時間：</p>
						<p className="queryInfoData">{sinceDate} ~ {untilDate}</p>
					</div>
					<div className="queryInfoBox">
						<p className="queryInfoTitle">篩選平台：</p>
						<p className="queryInfoData">{sourceValue}</p>
					</div>
				</div>
				<ProfileSourceTab leaderInfo={kolprofile.data.meta} kolprofile={kolprofile.data.source}/>
				<div className="profile_post">
					{this.checkEmptyTag(location.query, postlist)}
					<div className="popular_post">
						<p className="sectionTitle">近半年熱門貼文</p>
						<RenderPopularBoxInfo postlist={postlist} />
					</div>
				</div>
	        </div>
	    )
   }

}

function mapStateToProps({ login, kolprofile, kolprofile_isloading, kolprofile_error, postlist, postlist_isloading, postlist_error, myfavorite, myfavorite_isloading, myfavorite_error}) {
  return { login, kolprofile, kolprofile_isloading, kolprofile_error, postlist, postlist_isloading, postlist_error, myfavorite, myfavorite_isloading, myfavorite_error };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ fetch_postlist, fetch_kolprofile, fetch_myfavorite }, dispatch);
}

export default connect(mapStateToProps,mapDispatchToProps )(Profile);



// WEBPACK FOOTER //
// ./src/containers/profile.js